import Language from "@/domain/enums/Language";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import ICU from "i18next-icu";
import { initReactI18next } from "react-i18next";
import en from "./en/translation.json";
import fr from "./fr/translation.json";

/**
 * Restore default language to Language.ENGLISH and add it to supported languages when SDK is ready to accept en-US language
 */
const DEFAULT_LANGUAGE = Language.FRENCH;
const SUPPORTED_LANGUAGES = [Language.FRENCH];

const translations: Record<Language, any> = {
    [Language.ENGLISH]: {
        translation: en,
    },
    [Language.FRENCH]: {
        translation: fr,
    },
};

i18n.use(LanguageDetector)
    .use(ICU)
    .use(initReactI18next)
    .init({
        supportedLngs: SUPPORTED_LANGUAGES,
        fallbackLng: DEFAULT_LANGUAGE,
        resources: translations,
        interpolation: { escapeValue: false },
        detection: {
            // Map browser language to our supported languages
            convertDetectedLanguage: (lng: string) => {
                if (lng.startsWith("fr")) {
                    return Language.FRENCH;
                }
                if (lng.startsWith("en")) {
                    return Language.ENGLISH;
                }

                return Language.ENGLISH;
            },
        },
    })
    .catch((error) => {
        console.error("Error initializing i18next:", error);
    });

export default i18n;
